var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"second-text text-center"},[_c('div',[_vm._v(_vm._s(_vm.value.name))]),_c('div',[_vm._v(_vm._s(_vm.value.email))])])
}
var staticRenderFns = []

export { render, staticRenderFns }